/**
 * HTTP service for the metering feature (PX-W6.4): the two READ endpoints of
 * `MeteringController` (`server/conf/routes`, verified 2026-09-04). The
 * ingest POST is org/machine-only and is deliberately absent — this client
 * never calls it.
 *
 * `?what=` selects the response shape (summary / daily / by-agent); it is a
 * QUERY param (the transport's `{orgId}` rewrite touches only the path).
 * The run-budget GET answers 404 `metering.budget.not-found` when the project
 * has no active budget — the slice reads that as `remainingMissing`.
 */

import { apiClient } from '@/services'

import type { MeteringUsageShape, RemainingBudget, UsageSummary } from '../types'

export const meteringServiceHttp = {
  /** The usage projection for the selected shape. */
  usage(projectId: string, what: MeteringUsageShape): Promise<UsageSummary> {
    return apiClient.get<UsageSummary>(`/{orgId}/projects/${projectId}/metering/usage`, {
      params: { what }
    })
  },

  /** What is left of the run budget — 404 when no active budget exists. */
  runBudget(projectId: string): Promise<RemainingBudget> {
    return apiClient.get<RemainingBudget>(`/{orgId}/projects/${projectId}/metering/budget`)
  }
}
